import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import { adminGetAllTubeLibrary, adminGetTubeLibrary, resetFocusTubeLibrary } from "services/tubeLibrary";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid } from "semantic-ui-react";
import GeneralForm from "features/Admin/Tubes/Forms/GeneralForm";
import { Form, Formik } from "formik";
import SecondaryButton from "components/Buttons/SecondaryButton";
import PhotoForm from "features/Admin/Tubes/Forms/PhotoForm";
import AliquotForm from "features/Admin/Tubes/Forms/AliquotForm";

class TubeLibraryAdmin extends Component {
	constructor(props) {
		super(props);

		this.state = {
			tubesAliquotsFactory: {
				list: this.props.tubes.list.data,
				selected: [],
				listLabel: "Liste des tubes",
				selectedLabel: "Tubes aliquots sélectionnés",
				tmp: {
					add: [],
					remove: [],
				},
			},
		};
	}

	setupFactories = (elt) => {
		this.setState({
			tubesAliquotsFactory: {
				list: this.props.tubes.list.data.map((i) => {
					return { ...i, persisted: false };
				}),
				selected:
					elt !== undefined && elt !== null && elt.tubes !== undefined
						? elt.aliquots.map((i) => {
								return { ...i, persisted: true };
						  })
						: [],
				listLabel: this.state.tubesAliquotsFactory.listLabel,
				selectedLabel: this.state.tubesAliquotsFactory.selectedLabel,
				tmp: this.state.tubesAliquotsFactory.tmp,
			},
		});
	};

	resetFactories = () => {
		this.setState({
			tubesAliquotsFactory: {
				list: this.state.tubesAliquotsFactory.list,
				selected: this.state.tubesAliquotsFactory.selected,
				listLabel: this.state.tubesAliquotsFactory.listLabel,
				selectedLabel: this.state.tubesAliquotsFactory.selectedLabel,
				tmp: {
					add: [],
					remove: [],
				},
			},
		});
	};

	componentDidMount() {
		this.getAllElements();
		if (this.props.tubes.focus.data !== null) {
			this.setupFactories(this.props.tubes.focus.data);
		}
	}

	componentWillUnmount() {
		this.props.resetFocusTubeLibrary();
	}
	componentDidUpdate(prevProps) {
		if (this.props.tubes.focus.data !== prevProps.tubes.focus.data) {
			this.setupFactories(this.props.tubes.focus.data);
		}
	}

	getAllElements = () => {
		this.props.adminGetAllTubeLibrary();
	};

	focusOnElement = (elt) => {
		this.props.adminGetTubeLibrary(elt);
	};

	render() {
		let { focus, list } = this.props.tubes;
		let tube = focus.data;
		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="TUBES"
					defaultLabel={(e) => e.code}
					focusedEltId={tube}
					groupField="group"
				/>

				<ElementFocus element={focus} list={list} entity="Tubes" icon="lab">
					{tube !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: tube.id,
								code: tube.code || "",
								comment: tube.comment || "",
								dissociate_form: Boolean(tube.dissociate_form),
								img_filename: tube.img_filename || "",
								group: tube.group || "",
								img_path: tube.img_path || "",
								label: tube.label || "",
								sil_code: tube.sil_code || "",
								take_number_before_display: tube.take_number_before_display || 1,
								volume: tube.volume || 1000,
								timer: tube.timer || 0,
								timer_before_result: tube.timer_before_result || 0,
								regex: tube.regex || "",
								aliquot: tube.aliquot || false,
								aliquots: tube.aliquots || [],
								primary: tube.primary || null,
								to_package: tube.to_package || false,
							}}
						>
							{() => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusTubeLibrary}>
													Fermer
												</SecondaryButton>
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={2}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>

											<Grid.Column>
												<AdminDataContainer ribbonColor="blue" ribbonLabel="Présentation">
													<PhotoForm element={tube} />
												</AdminDataContainer>
												<br />
												<AdminDataContainer ribbonColor="violet" ribbonLabel="Aliquots">
													<AliquotForm element={tube} tubesAliquotsFactory={this.state.tubesAliquotsFactory} />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocWhiteTubeLibrarysAdmin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		tubes: state.admin.tubes,
	};
};

const mapDispatchToProps = {
	adminGetAllTubeLibrary,
	adminGetTubeLibrary,
	resetFocusTubeLibrary,
};

export default connect(mapStateToProps, mapDispatchToProps)(TubeLibraryAdmin);
